import { render, staticRenderFns } from "./AgencyShippingWrite.vue?vue&type=template&id=f06971e8&scoped=true"
import script from "./AgencyShippingWrite.vue?vue&type=script&lang=js"
export * from "./AgencyShippingWrite.vue?vue&type=script&lang=js"
import style0 from "./AgencyShippingWrite.vue?vue&type=style&index=0&id=f06971e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06971e8",
  null
  
)

export default component.exports